import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { LocalstorageService } from '../../../global/localstorage.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { DashboardService } from '../../../main/dashboard/dashboard.service';
import { FooterService } from './footer.service';
import { first } from 'rxjs/operators';
import { UpdatefontsizeService } from '../../../services/updatefontsize.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  getlen: string;
  @ViewChild("ddllanguage", { static: false }) ddllanguage;
  footerLan: string;
  addLan: string;
  mobileLan: string;
  footerlan1: string;
  CurrentDate:string=formatDate(new Date(), 'dd/MM/yyyy HH:mm:ss', 'en');
  VisitorCount:any;
  public Visitorcnt: any[];
  VisitorsLan: string;
  
  LastUpdatedLan: string;
  DateModified: any[];
  Datemodified: any;
  fontSize = 14;
  NASize = this.fontSize;
  Disclaimer: string;
  UserId: string;

  constructor(public router: Router, public dashboardService: DashboardService, public footerService: FooterService, private updateFont : UpdatefontsizeService) {
  }
  selected = '';


  ngOnInit() {
    this.getlen = LocalstorageService.getLanguage("language");
    
    if (this.getlen == null) {
      LocalstorageService.setLanguage("language", "en");
      this.selected = "en";
    }
    else {
      this.getlen = LocalstorageService.getLanguage("language");
      LocalstorageService.setLanguage("language", this.getlen);
      this.selected = this.getlen;
    }

    if(this.getlen == "en") {
      this.footerLan = "Nashik Mahanagar Parivahan Mahamandal Limited";
      this.addLan = "CITILINC Bhavan, Golf Club Ground, Trimbak Road, Nashik - 422002";
      this.mobileLan = "0253-2677013";
      this.footerlan1 = "(SPV of Nashik Municipal Corporation)";
      this.VisitorsLan = "Visitor Count";
      this.LastUpdatedLan = "Last Updated";
      this.Disclaimer = "This application is under testing and observation.";
    } else if (this.getlen == "mr") {
      this.footerLan = "नाशिक महानगर परिवहन महामंडल लिमिटेड";
      this.addLan = "सिटीलिंक भवन, गोल्फ क्लब मैदान, त्र्यंबक रोड, नाशिक - ४२२००२";
      this.mobileLan = "0172-2677013";
      this.footerlan1 = "(नाशिक महानगरपालिकेचे विशेष हेतू वाहन)";
      this.VisitorsLan = "अभ्यागतांना";
      this.LastUpdatedLan = "शेवटचे अद्यावत";
      this.Disclaimer = "ही वेबसाइट चाचणी आणि निरिक्षण अंतर्गत आहे.";
    } else {
      this.footerLan = "नाशिक महानगर परिवहन महामंडळ लिमिटेड";
      this.addLan = "एन.एम.पी.एम.एल,जवळ गोल्फ क्लब मैदानावर यार्ड,वीर सावरकर तरण तलाव, त्रंबकेश्वर रोड,नाशिक - ४२२००२";
      this.mobileLan = "0253-2677013";
      this.footerlan1 = "(एसपीव्ही नाशिक महानगरपालिकेचे विशेष हेतू वाहन)";
      this.Disclaimer = "ही वेबसाइट चाचणी आणि निरिक्षण अंतर्गत आहे.";
    }

    //update font size daynamic
    this.updateFont.currentFontSource$.subscribe((type) => {
      if(type == '+'){
        if (this.fontSize < (this.NASize + 3)) {
          this.fontSize++;
        }
      } else if(type == '-'){
        if (this.fontSize > (this.NASize - 3)) {
          this.fontSize--;
        }
      } else {
          this.fontSize = this.NASize;
      }
    });

    this.UserId = LocalstorageService.getLocal('user');
    this.GetDateModifiedData();
    this.GetVisitor();
  }
  
  GetDateModifiedData() {
    this.footerService.GetDateModified().pipe(first()).subscribe(result => {
      this.DateModified = JSON.parse(result.data);
      this.Datemodified = this.DateModified[0]["lastupdate"];
    })
  
    }
  GetVisitor() {
    this.dashboardService.GetVisitorCount().pipe(first()).subscribe(result => {
      this.Visitorcnt = JSON.parse(JSON.stringify(result.data));
      this.VisitorCount= this.Visitorcnt[0]["count_visitor"];
    });
  }
  onLanguageChange(event) {
    const newVal = event;
    LocalstorageService.setLanguage("language", newVal);
    this.selected = newVal;
    window.location.reload();
  }

}
